






import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class Typeform extends Vue {
    @Prop({ required: true }) urlNl!: string;

    @Prop({ required: true }) urlEn!: string;

    @Prop({ required: true }) urlFr!: string;

    @Prop({ required: true }) title!: string;

    get lang() {
        // return the lang from the html tag
        return document.documentElement.lang;
    }

    get calendlyLink() {
        if (this.lang === "nl") {
            return this.urlNl;
        } else if (this.lang === "fr") {
            return this.urlFr;
        } else if (this.lang === "en") {
            return this.urlEn;
        }
        return this.urlNl;
    }

    openCalendly() {
        //@ts-ignore
        Calendly.initPopupWidget({ url: this.calendlyLink });
    }
}
